import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { SiteImpressions } from 'shared/events/site_conversion_tracking_helper';
import { bubEvents } from 'shared/events/bub_events';

import styles from 'stylesheets/components/award_ribbon.module';

import ribbonImage from 'images/award_ribbon.png';

export function AwardRibbon({ heading, viewAllLink, trackingCategory, trackingProperties }) {

  useEffect(() => {
    if (trackingCategory && trackingProperties) {
      SiteImpressions.trackImmediately({
        category: trackingCategory,
        action: 'Viewed component',
        eventLabel: trackingProperties.label,
        eventValue: trackingProperties.value,
      });
    }
  }, []);

  function onViewAllLinkClicked() {
    if (trackingCategory && trackingProperties) {
      bubEvents.track(trackingCategory, 'Clicked view all link', {
        ...trackingProperties
      });
    }
  }

  return (
    <div className={styles.awardRibbon} data-testid='award-ribbon'>
      <div className={styles.ribbonImageWrapper}>
        <img className={styles.ribbonImage} src={ribbonImage} alt="Award Ribbon" />
      </div>
      <div className={styles.textBlock}>
        <h3 className={styles.heading}>{heading}</h3>
        <a className={styles.viewAllLink} onClick={onViewAllLinkClicked} href={viewAllLink}>View All</a>
      </div>
    </div>
  );
};

AwardRibbon.propTypes = {
  heading: PropTypes.string.isRequired,
  viewAllLink: PropTypes.string.isRequired,
  trackingCategory: PropTypes.string,
  trackingProperties: PropTypes.object,
};
